// extracted by mini-css-extract-plugin
export default {"knowledge":"style_knowledge__2HVRR","wrapper":"style_wrapper__Msxn8","description":"style_description__efVko","image":"style_image__2hApT"};